<template lang="pug">
div
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :listaProcessosSelecionados="processosSelecionados.map((processo) => processo.id)",
      :configuracaoFiltro="configuracaoFiltro"
    )
  app-listagem(
    v-if="!loading",
    :headerLabel="'Adicionar/Remover Processos'",
    :showButtonOrdemServico="false",
    :has-refresh-button="true",
    @updateListagem="carregarLista",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    @changePage="changePage",
    @sort="sortEdicao",
    @executar="executar",
    :pagina="filtro.pagina",
    :isVincularEquipe="true",
    @selectItem="selecionaProcesso"
  )
  span.padding-left {{ 'Processos Selecionados: ' + this.processos.length }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import { cloneDeep } from 'lodash'
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  components: {
    AppListagem,
    Filtro,
    AppButtonsCadastro
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('LISTAGEM_PROCESSO_ORDEM_SERVICO', this.numero),
      items: [],
      loading: false,
      totalElements: 0,
      processosSelecionados: [],
      idsProcessos: [],
      configuracaoFiltro: {},
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => true, ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Status da Viagem de Campo', propriedade: 'statusSubProcessos', ordem: 6, acoes: [] }
      ]
    }
  },

  props: {
    numero: {
      required: false
    },
    edicao: {
      required: false,
      default: false
    },
    load: {
      required: false,
      default: false
    }

  },

  async created () {
    if (this.processos?.length > 0) {
      this.processosSelecionados = this.processos
      this.items = this.items.map(i => {
        i.selecionado = !this.processos.find(p => p.id === i.id)
        i.disabled = []
      })
      this.setProcessoSelecionados({ processos: this.processosSelecionados, map: true })
    }
    this.carregarLista()
  },

  computed: {
    ...mapState({
      processos: state => state.ordemServico.processos
    })
  },

  methods: {
    ...mapActions({
      getOrdemServicoPorNumero: 'ordemServico/getOrdemServicoPorNumero',
      setProcessoSelecionados: 'ordemServico/setProcessoSelecionados',
      ordemServicoClear: 'ordemServico/clear'
    }),

    async selecionaProcesso (item) {
      item.selecionado = !item.selecionado
      this.items = cloneDeep(this.items)
      if (item.selecionado) {
        this.processosSelecionados.push(item)
      } else {
        const indexProcesso = this.processosSelecionados.findIndex((processoSelecionado) => processoSelecionado.id === item.id)

        if (indexProcesso !== -1) {
          this.processosSelecionados.splice(indexProcesso, 1)
        }
      }

      this.setProcessoSelecionados({ processos: this.processosSelecionados, map: true })
    },

    async sortEdicao (item) {
      if (item.ordem === 'tipo') item.ordem = 'tipo'
      this.sort(item)
    },

    verificarProcessosSelecionados () {
      if (this.processos?.length > 0) {
        this.processos.forEach((processoSelecionado) => {
          this.items = this.items.map((item) => {
            if (processoSelecionado.numero === item.numeroProcesso) {
              if (!item.statusSubprocesso) {
                item.statusSubprocesso = []
              }

              item.statusSubprocesso.push(processoSelecionado.status)
            }

            if (processoSelecionado.id === item.id) {
              item.selecionado = true
            }
            return item
          })
        })
        this.processosSelecionados = this.processos
        this.setProcessoSelecionados({ processos: this.processos, map: true })
      } else {
        this.processosSelecionados.forEach((processoSelecionado) => {
          this.items = this.items.map((item) => {
            if (processoSelecionado.id === item.id) {
              item.selecionado = true
            }
            return item
          })
        })
        this.setProcessoSelecionados({ processos: this.processosSelecionados, map: true })
      }
    },

    cancelar () {
      this.$router.back()
    },

    async carregarLista () {
      this.ordemServico = await this.getOrdemServicoPorNumero(this.numero)
      this.filtro.numeroOs = this.numero
      await this.initProcessosOrdemServico()
      this.verificarProcessosSelecionados()
    }
  }
}
</script>
<style lang="scss", scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
.padding-left {
  padding-left: 25px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/ListagemProcessoOrdemServico.vue